import { BaseService } from './base'
import { APIPath } from 'utility/constant'

class Announcement {
    getAnnouncements() {
        return BaseService.get(APIPath.announcement)
    }

    getAnnouncementById(id) {
        return BaseService.get(`${APIPath.announcement}/${id}`)
    }

    getUnreadCount() {
        return BaseService.get(APIPath.announcementUnreadCount)
    }

    create(data) {
        return BaseService.postExact(APIPath.announcement, data)
    }

    update(id, data) {
        return BaseService.put(`${APIPath.announcement}/${id}`, data)
    }

    deactivate(id) {
        return BaseService.post(APIPath.announcementDeactivate(id))
    }

    markAsRead(id) {
        return BaseService.post(APIPath.announcementRead(id))
    }
}

const AnnouncementService = new Announcement()
Object.freeze(AnnouncementService)
export { AnnouncementService }
